module.exports = __webpack_public_path__ + "static/media/Trazado 9260.d4381b17.png";